import React, { useEffect, useState } from "react";
import { TablePagination, Modal, Box, FormControl, OutlinedInput, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAuthFetch from "../../hooks/useAuthFetch";
import CustomTable from "../table/CustomTable";
import CustomTableRow from "../table/CustomTableRow";
import TableHeader from "../table/TableHeader";
import MainTableBody from "../table/MainTableBody";
import { LoadingTableSkeleton } from "../../utils/common";
import NoDataTable from "../table/NoDataTable";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Add, CloseOutlined, DeleteOutline, EditOutlined } from "@mui/icons-material";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/useDebounce";
import Cookies from "js-cookie";

import VCActionsModal from "./VCActionsModal";
import ViewDetialsModal from "./viewDetialsModal";



const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 4,
  borderRadius: 2,
};

const FunctionalityTemplateList = () => {


  const columns = ["Utility Name", "Utility Description", "Actions"];
  const [openErr, setOpenErr] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const userRole = JSON.parse(Cookies.get("userDets") || "{}").role;
  const [selectedRowCode, setSelectedRowCode] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openUtility = (code) => {
    setSelectedRowCode(code);
    setIsModalOpen(true);
  };
  return (
    <div className="py-1 px-4" style={{ height: `calc(100vh - 100px)` }}>
      <div className="flex flex-row mb-4 items-center justify-between">
        <p className="text-xl mb-0 font-extrabold">
          Utilities
        </p>
        <div className="flex gap-2 items-center">
        </div>
      </div>

      {/* <CustomTable className="w-full border-collapse">
        <TableHeader columns={columns} />
        <MainTableBody>
          {[
            { name: "Update Customer Image", code: "CIN" },
            { name: "Update Journey Screenshots", code: "NJS" },
            { name: "Update Customer PDF", code: "UPDF" },
            { name: "Update Customer Image (Direct)", code: "directDB" },
          ].map((item) => (
            <tr key={item.code} className="border-b hover:bg-gray-50">
              <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium px-3 py-3 no-underline css-1nutu1g-MuiTableCell-root">{item.name}</td>
              <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium px-3 py-3 no-underline css-1nutu1g-MuiTableCell-root">Utility Description</td>
              <td >
                {userRole === "ADMIN" && (
                  <VCActionsModal
                    key={item.code}
                    defaultUtility={item.code}
                    setErrMsg={setErrMsg}
                    setOpenErr={setOpenErr}
                  />
                )}
              </td>
            </tr>
          ))}
        </MainTableBody>
      </CustomTable> */}
      {userRole === "ADMIN" && (

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-4">
          {[
            { name: "Update Customer Image", code: "CIN", desc: "Update customer profile photos in the system." },
            { name: "Update Journey Screenshots", code: "NJS", desc: "Refresh screenshots for the user journey flow." },
            { name: "Update Customer PDF", code: "UPDF", desc: "Regenerate or update customer document PDFs." },
            { name: "Update Customer Image (Direct)", code: "direct-DB", desc: "Direct database update for profile images." },
            { name: "Restore PIVV Video", code: "Video-Restore", desc: "Restore missing or archived PIVV video files." },
            { name: "Restore PIVV PDF", code: "PDF-Restore", desc: "Restore missing or archived PIVV PDF documents." },
            // { name: "KYP Status", code: "kypSync", desc: "Cross-platform PIVV status synchronization for UDS, MCA, and DIGI modules." },
          ].map((item) => (
            <div
              key={item.code}
              className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 p-5 flex flex-col justify-between min-h-[180px]"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-blue-50 text-blue-600 text-[10px] font-bold px-2 py-0.5 rounded border border-blue-100 uppercase tracking-widest">
                    {item.code}
                  </span>
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-1 leading-tight">
                  {item.name}
                </h3>

                <p className="text-xs text-gray-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>

              <div className="mt-6 flex gap-2 justify-end">

                {userRole === "ADMIN" && (
                  <ViewDetialsModal
                    key={`${item.code}-${item.id}`}
                    defaultUtility={item.code}
                    setErrMsg={setErrMsg}
                    setOpenErr={setOpenErr}
                    isIconButton={true}
                  />
                )}
                {userRole === "ADMIN" && (
                  <VCActionsModal
                    key={item.code}
                    defaultUtility={item.code}
                    setErrMsg={setErrMsg}
                    setOpenErr={setOpenErr}
                    isIconButton={true}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}


    </div>
  );
};

export default FunctionalityTemplateList;
